import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import { regExpMail, regexpAlphanumeric, regexbAbsoluteUri, regexpInt } from "@/js/regexp_validation.js";
export var formRules = {
  notRequiredEmail: function notRequiredEmail(value) {
    return String.isNullOrEmpty(value === null || value === void 0 ? void 0 : value.toString()) || regExpMail.test(value) || "This field should be a valid email address, or empty";
  },
  mustBeEmail: function mustBeEmail(value) {
    return !!value && regExpMail.test(value) || "This field should be a valid email address";
  },
  mustBeEmails: function mustBeEmails(values) {
    return values.every(function (x) {
      return regExpMail.test(x);
    }) || "This field should be filled with valid email addresses only";
  },
  mustBeAlphanumeric: function mustBeAlphanumeric(value) {
    return !!value && regexpAlphanumeric.test(value) || "This field is required and must contain only alphanumeric characters";
  },
  mustSelectValue: function mustSelectValue(value) {
    if (Array.isArray(value)) return !!value.length || "This field is required";
    return !!value || "This field is required";
  },
  mustSelectValueZeroOk: function mustSelectValueZeroOk(value) {
    if (Array.isArray(value)) return !!value.length || "This field is required";
    return value === 0 || !!value || "This field is required";
  },
  mustNotBeEmpty: function mustNotBeEmpty(value) {
    return !String.isNullOrEmpty(value === null || value === void 0 ? void 0 : value.toString()) || "This field is required";
  },
  mustBeIntNotNegative: function mustBeIntNotNegative(value) {
    return regexpInt.test(value) || "This field should be an integer";
  },
  mustBeGreaterThan0: function mustBeGreaterThan0(value) {
    return !isNaN(value) && +value > 0 || "This field should be greater than 0";
  },
  mustBeGreaterThan: function mustBeGreaterThan() {
    var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function (value) {
      return !isNaN(value) && +value > min || "This field should be greater than ".concat(min);
    };
  },
  mustBeGreaterOrEqualThan: function mustBeGreaterOrEqualThan() {
    var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function (value) {
      return !isNaN(value) && +value >= min || "This field should be greater or equal than ".concat(min);
    };
  },
  mustBeLowerThan: function mustBeLowerThan() {
    var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function (value) {
      return !isNaN(value) && +value < max || "This field should be lower than ".concat(max);
    };
  },
  mustBeLowerOrEqualThan: function mustBeLowerOrEqualThan() {
    var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function (value) {
      return !isNaN(value) && +value <= max || "This field should be lower or equal than ".concat(max);
    };
  },
  mustBeDecimalNotNegative: function mustBeDecimalNotNegative(value) {
    return !isNaN(value) && +value >= 0 || "This field can't be negative";
  },
  mustBeGreaterThan0OrEmpty: function mustBeGreaterThan0OrEmpty(value) {
    return value === null || value === "" || !isNaN(value) && +value > 0 || "This field should be greater than 0 or empty";
  },
  mustBeHttpLinkOrEmpty: function mustBeHttpLinkOrEmpty(value) {
    var isValid = !value || regexbAbsoluteUri.test(value);
    return isValid || "This field should be a valid url, or empty. Make sure the url starts with http:// or https://";
  },
  mustBeTime: function mustBeTime(value) {
    var pattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
    return pattern.test(value) || "Invalid time format. Use hh:mm";
  },
  mustBeDate: function mustBeDate(value) {
    var date = new Date(value);
    return !isNaN(date.getTime()) || "Must be a valid date";
  }
};